export default __webpack_public_path__ + "static/media/predictionmodel.3ee89be6.png";